import { findIndex, filter, isEmpty } from 'underscore';

export const DisplayUrlModes = [
  'ManufacturerWebsiteUrl',
  'WebsiteDescription',
];

export const WebsiteDescriptionLanguages = [
  _TL_('English'),
  _TL_('Spanish'),
];

export const WebsiteDescriptionOptions = [
  {
    key: 'PrescriptionTreatmentWebsite_Es',
    value: 'Sitio de tratamientos con receta',
  },
  {
    key: 'PrescriptionTreatmentWebsite_En',
    value: 'Prescription treatment website',
  },
  {
    key: 'PrescriptionDeviceWebsite_Es',
    value: 'Sitio de dispositivos con receta',
  },
  {
    key: 'PrescriptionDeviceWebsite_En',
    value: 'Prescription device website',
  },
  {
    key: 'MedicalDeviceWebsite_Es',
    value: 'Sitio de dispositivos médicos',
  },
  {
    key: 'MedicalDeviceWebsite_En',
    value: 'Medical device website',
  },
  {
    key: 'PreventativeTreatmentWebsite_Es',
    value: 'Sitio de tratamientos preventivos',
  },
  {
    key: 'PreventativeTreatmentWebsite_En',
    value: 'Preventative treatment website',
  },
  {
    key: 'PrescriptionContraceptionWebsite_Es',
    value: 'Sitio de anticonceptivos con receta',
  },
  {
    key: 'PrescriptionContraceptionWebsite_En',
    value: 'Prescription contraception website',
  },
  {
    key: 'PrescriptionVaccineWebsite_Es',
    value: 'Sitio de vacunas con receta',
  },
  {
    key: 'PrescriptionVaccineWebsite_En',
    value: 'Prescription vaccine website',
  },
];

export const getWebsiteDescriptionList = (key) => {
  const index = findIndex(WebsiteDescriptionOptions, option => option.key === key);
  const mod = (index + 1) % 2;
  return {
    language: WebsiteDescriptionLanguages[mod],
    websiteDescriptions: filter(WebsiteDescriptionOptions, (option, idx) => (idx % 2) !== mod),
  };
};

export const getWebsiteDescriptionInAnotherLanguage = (key, langIndex = 0) => {
  let index = findIndex(WebsiteDescriptionOptions, option => option.key === key);
  if (index === -1) {
    index = langIndex;
  }
  return WebsiteDescriptionOptions[index + ((-1) ** (index % 2))].key;
};

export const isWebsiteDescriptionUnspecified = key => isEmpty(key) || key === 'Unspecified';
